const BASE = process.env.REACT_APP_API_URL?.replace(/\/$/, '') || '';

let _getToken = () => null;
export const setTokenGetter = (fn) => { _getToken = fn; };

async function req(method, path, body) {
  const token = _getToken();
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `HTTP ${res.status}`);
  }
  return res.json();
}

export const api = {
  // Dashboard
  getDashboard: ()            => req('GET',  '/dashboard'),

  // Posts
  getPosts:    (qs = '')      => req('GET',  `/posts${qs}`),
  triggerPost: ()             => req('POST', '/posts/trigger'),
  triggerReel: ()             => req('POST', '/posts/trigger-reel'),

  // Brand voice
  getBrandVoice:   ()         => req('GET',    '/brand-voice'),
  triggerAnalysis: ()         => req('POST',   '/brand-voice/analyze'),
  getUploadUrl:    ()         => req('GET',    '/brand-voice/upload-url'),
  savePosts:       (body)     => req('POST',   '/brand-voice/posts', body),
  getStoredPosts:  ()         => req('GET',    '/brand-voice/posts'),
  deleteStoredPosts: ()       => req('DELETE', '/brand-voice/posts'),

  // Escalations
  getEscalations: (qs = '')   => req('GET',  `/escalations${qs}`),
  resolveEscalation: (id)     => req('PUT',  `/escalations/${id}/resolve`),

  // Leads
  getLeads: (qs = '')         => req('GET',  `/leads${qs}`),
  updateLead: (id, status)    => req('PUT',  `/leads/${id}/status`, { status }),

  // Comments
  getComments: (qs = '')      => req('GET',  `/comments${qs}`),

  // Messages
  getMessages:    (qs = '')   => req('GET',  `/messages${qs}`),
  fetchMessages:  ()          => req('POST', '/messages/fetch'),

  // Audit log
  getAuditLog: (qs = '')      => req('GET',  `/audit${qs}`),

  // Reel assets
  getReelAssets:     ()                    => req('GET',    '/assets/reel'),
  getReelUploadUrl:  (type, filename = '') => req('GET',    `/assets/reel/upload-url?type=${type}${filename ? '&filename=' + encodeURIComponent(filename) : ''}`),
  deleteReelAsset:   (key)                 => req('DELETE', `/assets/reel?key=${encodeURIComponent(key)}`),

  // Post schedule
  getPostSchedule:      ()         => req('GET', '/post-schedule'),
  updatePostSchedule:   (schedule) => req('PUT', '/post-schedule', { schedule }),
  setPostScheduleState: (state)    => req('PUT', '/post-schedule', { state }),

  // Brand images
  getBrandImages:         ()               => req('GET',    '/brand-images'),
  getBrandImageUploadUrl: (filename, type) => req('GET',    `/brand-images/upload-url?filename=${encodeURIComponent(filename)}&type=${encodeURIComponent(type)}`),
  confirmBrandImageUpload:(body)           => req('POST',   '/brand-images/confirm', body),
  deleteBrandImage:       (key)            => req('DELETE', `/brand-images/${encodeURIComponent(key)}`),
};
